module.exports = __webpack_public_path__ + "img/chd-bg-dummy.83c2ddbd.png";